export const FORM_FACTOR_DESKTOP = 'Desktop';
export const FORM_FACTOR_MOBILE = 'Mobile';
